import Paragraph from "@components/Paragraph";
import Highlight from "@components/Highlight";
import Video from "@components/Video";
import Images from "@components/Images";
import ImageText from "@components/ImageText";
import Gallery from "@components/Gallery";
import Quote from "@components/Quote";
import CTA from "@components/CTA";
import Hero from "@components/HeroBannerVimeo";
import Credits from "@components/Credits";
import Loader from "@components/Loader";
import SectionFeature from "@components/SectionFeature";
import SectionIntro from "@components/SectionIntro";
import SectionFooter from "@components/SectionFooter";

export const SECTIONS = { SectionIntro, SectionFeature, SectionFooter };
export const ELEMENTS = {
  Loader,
  Paragraph,
  Highlight,
  Headline: Highlight,
  HeroBannerVimeo: Hero,
  Separator: CTA,
  Video,
  Images,
  ImageText,
  Gallery,
  Quote,
  CTA,
  Credits,
};
